import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCopy } from "@fortawesome/free-regular-svg-icons"

export const CopyRegular = (props) => {
  return <FontAwesomeIcon faIcon={faCopy} {...props} />
}
